export enum Actions {
  REMOVE_CUSTOMER = 'removeCustomer',
  REMOVE_COVER = 'removeCover',
  OTHER = 'other',
}
